import { UpdateControlMetadata } from '../validators/helpers';

export function NoLabel(target: any, propertyKey: string) {
  UpdateControlMetadata(target, propertyKey, { label: null });
}

export function Label(label: string | null) {
  return function (target: any, propertyKey: string) {
    UpdateControlMetadata(target, propertyKey, { label });
  }
}
